import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import coin from '@/assets/icons/coin-icn-xs.svg';
import key from '@/assets/icons/key-icn-xs.svg';
import star from '@/assets/icons/star-icn-xs.svg';
import { Mission, MissionItem } from '@/components/Mission';
import { MissionLink } from '@/types/models/mission';
import { formatNumber } from '@/utils/format';

export type LinkMissionProps = {
  mission: MissionLink;
  completed: boolean;
  onClick: () => void;
};

export const Link = observer<LinkMissionProps>(
  ({ mission, onClick, completed }) => {
    const { t } = useTranslation();
    return (
      <Mission
        completed={completed}
        name={t(mission.name)}
        icon={mission.icon}
        onClick={onClick}
        missionBar={
          <>
            {mission.coins && (
              <MissionItem>
                <span>{`+ ${formatNumber(mission.coins)}`}</span>
                <img src={coin} />
              </MissionItem>
            )}
            {mission.keys && (
              <MissionItem>
                <span>{`+ ${formatNumber(mission.keys)}`}</span>
                <img src={key} />
              </MissionItem>
            )}
            {mission.xp && (
              <MissionItem>
                <span>{`+ ${formatNumber(mission.xp)}`}</span>
                <img src={star} />
              </MissionItem>
            )}
          </>
        }
      />
    );
  },
);
